import React from "react";
import ProgressBar from "@ramonak/react-progress-bar";
import "../css/ProgressBar_Total.css";

const SegmentedProgressBar = ({ completed }) => {
  const segments = [];
  for (let i = 0; i < 10; i++) {
    segments.push(<div key={i} className="progress-bar-segment2"></div>);
  }

  const getColor = (value) => {
    if (value < 20) return "red";
    if (value < 40) return "orange";
    return "green";
  };

  return (
    <div className="segmented-progress-bar-container2">
      <div className="segmented-progress-bar2">
        <ProgressBar
          className="progress-bar2"
          completed={completed}
          height="10px"
          bgColor={getColor(completed)}
          isLabelVisible={false}
          baseBgColor={"white"}
          padding="3px"
          borderRadius="100px"
        />
        <div className="progress-bar-overlay2">{segments}</div>
      </div>
      <div
        className="progress-percentage2"
        style={{ color: getColor(completed) }}>
        {Math.pow(completed, 1).toLocaleString("es")}%
      </div>
    </div>
  );
};

export default SegmentedProgressBar;
